import React, { useMemo, useCallback, useState } from "react";
import { useLocation } from "dva";
import { LoadStatus } from "@/utils/enum";
import { getTransporterLoads } from "@/services/loads";
import ListView from "@/components/ListView";
import { ListToBeSorted } from "@/components/SortAndFilter";
import useTransporterLoadsTableColumns from "./utils/useTransporterLoadsTableColumns";

const TransporterLoads = () => {
  const { pathname } = useLocation();
  const columns = useTransporterLoadsTableColumns();

  const [totalItems, setTotalItems] = useState(0);

  const currentSubPath = useMemo(() => pathname.split("/").pop(), [pathname]);

  const loadStatus = useMemo(() => {
    switch (pathname) {
      case "/loads/progress":
        return [LoadStatus.PickedUp, LoadStatus.Active];

      case "/loads/delivered":
        return LoadStatus.Delivered;

      case "/loads/completed":
        return LoadStatus.Completed;

      default:
        return undefined;
    }
  }, [pathname]);

  const fetchLoadsList = useCallback(
    async ({ filters }) => {
      const newFilters = {
        ...filters,
        status: loadStatus,
      };

      try {
        const response = await getTransporterLoads(newFilters);
        const { totalCount = 0, items = [] } = response?.data ?? {};
        setTotalItems(totalCount);

        return {
          data: items,
          total: totalCount,
          success: true,
        };
      } catch (error) {
        console.error(error);
        return {
          data: [],
          total: 0,
        };
      }
    },
    [loadStatus],
  );

  return (
    <ListView
      filterType={ListToBeSorted.TransporterLoads}
      columns={columns}
      tableStyle={{ padding: "0 24px" }}
      baseDetailsUrl={`/loads/${currentSubPath}/view`}
      totalItems={totalItems}
      detailsUrlParamName="loadId"
      request={fetchLoadsList}
    />
  );
};

export default TransporterLoads;
